import { decryptLocalStorage } from "../utils/localStorage.utils";

export const THEME_MODE = () => {
    return decryptLocalStorage(localStorage.getItem('theme'));
}

export const TOKEN = () => {
    return decryptLocalStorage(localStorage.getItem('advy-token'));
};

export const USER_ID = () => {
    return decryptLocalStorage(localStorage.getItem("uid"))
}

export const PROFILE = () => {
    return decryptLocalStorage(localStorage.getItem("profile"))
}

export const ORG_LIST = () => {
    return decryptLocalStorage(localStorage.getItem("org-list"))
}

export const ACCESS_LIST = () => {
    return decryptLocalStorage(localStorage.getItem("all-access-list"))
}

export const MY_ACCESS = () => {
    return decryptLocalStorage(localStorage.getItem('my-acc-list'));
}

export const AUTO_LOGIN_TOKEN = () => {
    return decryptLocalStorage(localStorage.getItem('advy-a-l-t'));
};

export const DASHBOARD_MODE = () => {
    return decryptLocalStorage(localStorage.getItem('d-mode'));
}

export const SELECTED_META_ACCOUNT = () => {
    return decryptLocalStorage(localStorage.getItem('meta-account'));
}

export const SELECTED_GOOGLE_ACCOUNT = () => {
    return decryptLocalStorage(localStorage.getItem('google-account'));
}